module.exports = __webpack_public_path__ + "img/1.cleaned_floor.7c330740.svg";